export type CallStatus =
  | 'idle'
  | 'connecting'
  | 'ringing'
  | 'in_call'
  | 'on_hold'
  | 'ended'

export interface Call {
  id: string
  remoteNumber: string
  remoteName?: string
  direction: 'inbound' | 'outbound'
  startedAt: Date
  answeredAt?: Date
  endedAt?: Date
  durationSeconds: number
  status: CallStatus
  muted: boolean
  onHold: boolean
  /** Cause SIP du dernier échec (Busy, Unavailable, Not Found…) — posée par
   *  le contrôleur sur l'event `failed`, utilisée pour l'auto-classement. */
  failureCause?: string
}

export function makeIdleCall(): Call {
  return {
    id: '',
    remoteNumber: '',
    direction: 'outbound',
    startedAt: new Date(),
    durationSeconds: 0,
    status: 'idle',
    muted: false,
    onHold: false,
  }
}
